import { Injectable } from '@angular/core';
import { PHBHPApiService } from 'ph-bhp-feature-packages/ph-bhp-layout-package/lib/ph-bhp-api.service';

@Injectable({
  providedIn: 'root'
})
export class PHBHPFeaturePackageChcService {

  constructor(private service: PHBHPApiService) {
    //this.service.apiUrl ="http://localhost:7000/api/"
  }

  GetCHCIntegerationLog(userId, roledId, countryId = 0, institutionId = 0) {
    return this.service.getApi(`CHCIntegration/GetwebKessIntegerationLog/${userId}/${roledId}/${countryId}/${institutionId}`, true);
  }

  getwebKessIntegerationLogByInstitutionId(institutionId) {
    return this.service.getApi(`CHCIntegration/GetwebKessIntegerationLogByInstitutionId/${institutionId}`, true);
  }

  getCHCIntegerationDataById(chcImportId,type) {
    return this.service.getApi(`ObservationSession/GetCHCIntegerationDataById/${chcImportId}/${type}`, true);
  }
  resetCHCImportStatus(chcImportId) {
    return this.service.getApi(`ObservationSession/ResetCHCImportStatus/${chcImportId}`, true);
  }
  resetCHCImportConsumptionsStatus(chcImportId) {
    return this.service.getApi(`Consumptions/ResetCHCImportStatus/${chcImportId}`, true);
  }
  syncCHCIntegration() {
    return this.service.getApi("CHCIntegration/IntervelsObservations", true);
  }
  checkPendingIntegrations(institutionId) {
    return this.service.getApi(`CHCIntegration/CheckPendingIntegrations/${institutionId}`, true);
  }
 
}
